import { render } from "./Paradero.vue?vue&type=template&id=d29c4e90&scoped=true"
import script from "./Paradero.vue?vue&type=script&lang=js"
export * from "./Paradero.vue?vue&type=script&lang=js"

import "./Paradero.vue?vue&type=style&index=0&id=d29c4e90&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d29c4e90"]])

export default __exports__